import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const blogs = [
  {
    title: '5 Tips to Improve Your Child’s Learning',
    excerpt: 'Discover practical strategies to help your child succeed academically and socially.',
    image: '/images/tips.jpg',
    date: 'June 30, 2025',
    author: 'Blessed Montessori',
    tag: 'Parenting',
  },
  {
    title: 'How Montessori Method Boosts Creativity',
    excerpt: 'Explore how the Montessori approach encourages independence and innovation in young learners.',
    image: '/images/Creative.jpg',
    date: 'June 28, 2025',
    author: 'Admin',
    tag: 'Montessori',
  },
  {
    title: 'Why Early Education Matters',
    excerpt: 'Understand the impact of early learning on long-term cognitive and emotional development.',
    image: '/images/Learning.jpg',
    date: 'June 25, 2025',
    author: 'Principal Grace',
    tag: 'Early Learning',
  },
  {
    title: 'Best Classroom Setups for Engaged Learning',
    excerpt: 'Classroom environment plays a big role in student success. Here’s how to set up yours.',
    image: '/images/class.jpg',
    date: 'June 23, 2025',
    author: 'Mrs. Joy',
    tag: 'Environment',
  },
  {
    title: 'Play-Based Learning: What You Should Know',
    excerpt: 'Play isn’t just fun—it’s powerful for brain development. Learn how we use it effectively.',
    image: '/images/Play&leard.jpg',
    date: 'June 20, 2025',
    author: 'Educator Mike',
    tag: 'Play & Learn',
  },
  {
    title: 'Helping Children with Special Needs Thrive',
    excerpt: 'We share inclusive strategies that help every child reach their full potential.',
    image: '/images/mhi.jpg',
    date: 'June 18, 2025',
    author: 'Inclusive Team',
    tag: 'Inclusion',
  },
];

const Blog = () => {
  return (
    <div className="text-gray-800 bg-gray-50">
      <Navbar />

      {/* Hero */}
      <section className="py-20 text-center text-white bg-blue-700">
        <div className="max-w-4xl px-4 mx-auto">
          <h1 className="mb-3 text-4xl font-bold md:text-5xl">📚 Our Blog</h1>
          <p className="text-lg opacity-90">Inspiring stories, insights & tips from the Blessed Montessori team.</p>
        </div>
      </section>

      {/* Blog Cards */}
      <section className="px-4 py-16 mx-auto sm:px-6 lg:px-8 max-w-7xl">
        <div className="grid gap-10 md:grid-cols-2 lg:grid-cols-3">
          {blogs.map((blog, index) => (
            <div key={index} className="overflow-hidden transition-all duration-300 transform bg-white rounded-lg shadow-xl hover:-translate-y-1 hover:shadow-2xl">
              <img
                src={blog.image}
                alt={blog.title}
                className="object-cover w-full h-56"
              />
              <div className="p-6">
                <span className="inline-block px-2 py-1 mb-2 text-xs text-blue-800 bg-blue-100 rounded">{blog.tag}</span>
                <h2 className="mb-2 text-xl font-bold text-gray-800">{blog.title}</h2>
                <p className="mb-4 text-gray-600">{blog.excerpt}</p>
                <div className="flex justify-between mb-4 text-sm text-gray-500">
                  <span>🖋 {blog.author}</span>
                  <span>📅 {blog.date}</span>
                </div>
                <button className="font-medium text-blue-600 transition hover:text-blue-800">Read More →</button>
              </div>
            </div>
          ))}
        </div>
      </section>
     {/* Video Gallery Section */}
<section className="py-20 bg-white dark:bg-neutral-900">
  <div className="max-w-6xl px-4 mx-auto text-center">
    <h2 className="mb-6 text-3xl font-bold text-gray-800 dark:text-white">
      🎬 Watch & Explore
    </h2>
    <p className="mb-10 text-gray-600 dark:text-gray-300">
      Videos from our school activities, events, and classroom stories.
    </p>

    <div className="grid gap-8 sm:grid-cols-2 lg:grid-cols-3">
      {[
        "dQw4w9WgXcQ", // Replace these with your own YouTube video IDs
        "M7lc1UVf-VE",
        "VYOjWnS4cMY",
      ].map((videoId, index) => (
        <div key={index} className="overflow-hidden rounded-lg shadow-lg aspect-w-16 aspect-h-9">
          <iframe
            className="w-full h-full"
            src={`https://www.youtube.com/embed/${videoId}`}
            title={`School Video ${index + 1}`}
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
        </div>
      ))}
    </div>
  </div>
</section>


      {/* Newsletter CTA */}
      <section className="py-16 text-center bg-gradient-to-br from-blue-100 to-blue-50">
        <div className="max-w-xl mx-auto">
          <h2 className="text-3xl font-bold text-gray-800">Subscribe for New Articles</h2>
          <p className="mt-2 text-gray-600">Get school news and parenting insights straight to your inbox.</p>
          <form className="flex flex-col items-center justify-center gap-4 mt-6 sm:flex-row">
            <input
              type="email"
              placeholder="Your email address"
              className="w-full px-5 py-3 border border-gray-300 rounded-lg sm:w-auto focus:ring-2 focus:ring-blue-500"
              required
            />
            <button
              type="submit"
              className="px-6 py-3 font-semibold text-white bg-blue-700 rounded-lg hover:bg-blue-800"
            >
              Subscribe
            </button>
          </form>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Blog;
